import React from 'react';
import {
  LineChart,
  Line,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  Legend,
  ResponsiveContainer,
} from 'recharts';

const formatCurrency = (value) => {
  if (value == null || isNaN(value)) return '$0';
  return `$${Number(value).toLocaleString()}`;
};

const StockInvestmentYearlyChart = ({ yearlyData }) => {
  if (!yearlyData || yearlyData.length === 0) {
    return <div className="text-center text-gray-500">No chart data available.</div>;
  }

  return (
    <div className="bg-white shadow-md rounded-lg p-6 mt-8">
      <h2 className="text-xl font-bold text-center text-blue-700 mb-6">
        Stock Value Over Time
      </h2>

      <ResponsiveContainer width="100%" height={500}>
        <LineChart
          data={yearlyData}
          margin={{ top: 20, right: 30, left: 20, bottom: 20 }}
        >
          <CartesianGrid strokeDasharray="3 3" />
          <XAxis dataKey="year" />
          <YAxis tickFormatter={(value) => `$${value / 1000}k`} />
          <Tooltip formatter={(value) => formatCurrency(value)} />
          <Legend />

          <Line
            type="monotone"
            dataKey="stockValue"
            stroke="#3b82f6"
            strokeWidth={3}
            name="Stock Value"
            dot={{ r: 3 }}
          />
        </LineChart>
      </ResponsiveContainer>
    </div>
  );
};

export default StockInvestmentYearlyChart;
